'use strict';

/**
 * fetchAppTemplate(appTemplateId, { AppTemplate }) — always resolves the
 * current app template from the API.
 *
 * #561/#820 — the app-store "add app" flow (edit-app.js) and the live
 * preview (app-preview-wrapper.js) used to special-case a pre-supplied
 * appTemplate object (from $stateParams or the shared Store) and skip the
 * network fetch entirely. That object was already in memory from an earlier
 * list request and did not reliably carry fields (e.g. integrationTemplate)
 * populated only on the single-record endpoint, so the integration picker
 * and live preview both silently no-op until a hard refresh forced the
 * fetch-fresh branch. Always fetching removes the divergent code path.
 *
 * @param {number|string} appTemplateId
 * @param {{AppTemplate: {findById: Function}}} deps
 * @returns {Promise<object>}
 */
function fetchAppTemplate(appTemplateId, { AppTemplate }) {
    return AppTemplate.findById({ id: appTemplateId }).$promise;
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        fetchAppTemplate,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('fetchAppTemplate', fetchAppTemplate);
}
